
"use client"
import { useEffect, useState } from "react";


 const useSelectStyles = (inputTextPaddingSize, inputTextFontSize, theme) => {
  // const mounted = useMounted();
  // let wndow;
  // useEffect(() => {
  //   wndow = window
  // }, [wndow])

// const [isDarkMode, setIsDarkMode] = useState(false);

//   useEffect(() => {
//         // if (!mounted) return;
//     const media = window.matchMedia("(prefers-color-scheme: dark)");

//     setIsDarkMode(media.matches);

//     const handler = (e) => setIsDarkMode(e.matches);
//     media.addEventListener("change", handler);

//     return () => media.removeEventListener("change", handler);
//   }, []);

  
  // const [isDark, setIsDark] = useState(false)
  // const [mounted, setMounted] = useState(false)
  //   useEffect(() => {
  //     setMounted(true)
  //         const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
  //     setIsDark(mediaQuery.matches)
  //   // setIsDarkMode(window?.matchMedia && window?.matchMedia('(prefers-color-scheme: dark)').matches);
  //         const handler = (e) => setIsDark(e.matches);

  //   mediaQuery.addEventListener("change", handler);

  //   return () => {
  //     mediaQuery.removeEventListener("change", handler);
  //   };
  //   }, [])


  //   const isDarkMode = mounted && isDark

//   let isDarkMode = false
// useEffect(() => {
//   isDarkMode = window && window.matchMedia && window?.matchMedia('(prefers-color-scheme: dark)').matches
// }, [])

 const isDarkMode = window.matchMedia && window?.matchMedia('(prefers-color-scheme: dark)').matches;

    // const isDarkMode = wndow?.matchMedia && window?.matchMedia('(prefers-color-scheme: dark)').matches
    

  let styles;
  if (theme === 'TOPICS'){
        styles = {
         control: (baseStyles, state) => ({
           ...baseStyles,
           color:'#6B7280', 
          //  backgroundColor: 'inherit',
          backgroundColor: isDarkMode ? 'inherit' : '#F1F5F9',
          //  fontSize: '15px',
          fontSize: '0.875rem',
          //  borderColor: state.isFocused && '#94a3b8',
          border: isDarkMode ? '1px solid' : 'none',
          borderColor: '#334255 !important',
           minHeight: '3.5rem',
          //  height:'3.5rem',
          //  maxHeight: '3.5rem',
           padding: inputTextPaddingSize || '0px 8px 0px 8px', 
          //  borderRadius: '0.75rem', 
          borderRadius: '0.5rem',  // rounded-lg
          //  borderColor: isDarkMode ? '#475569 !important' : '#cbd5e1 !important',
           boxShadow: state.isFocused ? 'none' : baseStyles.boxShadow,
         }),
         input: (baseStyles) => ({
           ...baseStyles, 
           color:'#6B7280', 
         }),
         option: (baseStyles, state) => ({...baseStyles,
           fontSize: '14px', 
           zIndex: '30 !important',
           padding: '0px 0px 0px 12px !important',
          //  height:'10px',
           // backgroundColor: state.isFocused ? '#334255'  : 'inherit'
           backgroundColor: isDarkMode && state.isFocused ? '#334255' : isDarkMode ? 'inherit' : state.isFocused ? '#E2E8F0' : 'inherit',
           color: isDarkMode ? '#94A3B8' : '#6B7280'
           // backgroundColor: '#d1d1d1',
         }),
         menu: (provided) => ({
           ...provided,
           // Conditionally set the background color based on isDarkMode
           backgroundColor: isDarkMode ? '#0F172B' : '#fff',
           color: isDarkMode ? '#4B5563' : '#334255',
           
           
         }),
         singleValue: provided => ({
           ...provided,
           color: isDarkMode? '#94A2B8' : '#6B7280', 
           fontSize: '14px',
           
         }), 
         placeholder: (provided, state) => ({
           ...provided,
           color: isDarkMode? '#94A2B8' : '#9CA3AF', // Change this to your desired color
           fontSize: inputTextFontSize || '14px', // Optional: change this to adjust the font size

           // Additional placeholder styling can go here
         }),



        multiValue: (base) => ({
          ...base,
          backgroundColor: isDarkMode ? "#1E293B" : "#E2E8F0",
          borderRadius: "999px",
          padding: "0 4px",
          margin: "2px",
          height: '1.5rem',
          display:'flex',
          // justifyItems:'center',
          alignItems:'center'
        }),

        multiValueLabel: (base) => ({
          ...base,
          color: isDarkMode ? "#94A3B8" : "#475569",
          fontSize: "13px",
          fontWeight: 500,
          padding: "2px 6px",
        }),

        multiValueRemove: (base) => ({
          ...base,
          color: isDarkMode ? "#64748B" : "#64748B",
          borderRadius: "50%",
          padding: "2px",
          cursor: "pointer",
          ":hover": {
            backgroundColor: isDarkMode ? "#334155" : "#CBD5E1",
            color: "#EF4444",
          },
        }),
         
        //  group: baseStyles => ({...baseStyles, 
        //               borderRadius: '50px', 
        //  })
       }
  }
  else {
    styles = {
         control: (baseStyles, state) => ({
           ...baseStyles,
           color:'#6B7280', 
           backgroundColor: 'inherit',
          //  fontSize: '15px',
          fontSize: '0.875rem',
           borderColor: state.isFocused && '#94a3b8',
           minHeight: '3.5rem',
          //  maxHeight: '3.5rem',
           padding: inputTextPaddingSize || '4px 0px 4px 0px', 
           borderRadius: '8px', 
           borderColor: isDarkMode ? '#475569 !important' : '#cbd5e1 !important',
           boxShadow: state.isFocused ? 'none' : baseStyles.boxShadow,
         }),
         input: (baseStyles) => ({
           ...baseStyles, 
           color:'#6B7280', 
         }),
         option: (baseStyles, state) => ({...baseStyles,
           fontSize: '14px', zIndex: '30 !important',
           // backgroundColor: state.isFocused ? '#334255'  : 'inherit'
           backgroundColor: isDarkMode && state.isFocused ? '#334255' : isDarkMode ? 'inherit' : state.isFocused ? '#E2E8F0' : 'inherit',
           color: isDarkMode ? '#94A3B8' : '#6B7280'
           // backgroundColor: '#d1d1d1',
         }),
         menu: (provided) => ({
           ...provided,
           // Conditionally set the background color based on isDarkMode
           backgroundColor: isDarkMode ? '#0F172B' : '#fff',
           color: isDarkMode ? '#4B5563' : '#334255',
         }),
         singleValue: provided => ({
           ...provided,
           color: isDarkMode? '#94A2B8' : '#6B7280', 
           fontSize: '14px'
         }), 
         placeholder: (provided, state) => ({
           ...provided,
           color: isDarkMode? '#94A2B8' : '#6B7280', // Change this to your desired color
           fontSize: inputTextFontSize || '14px', // Optional: change this to adjust the font size
        
           // Additional placeholder styling can go here
         }),

         noOptionsMessage: (base) => ({
          ...base,
          fontSize: '0.875rem',
          padding: '12px 16px',
          color: isDarkMode ? '#94A3B8' : '#6B7280',
          backgroundColor: isDarkMode ? '#0F172B' : '#fff',
          textAlign: 'left',
        })
         
         // group: baseStyles => ({...baseStyles, 
         //   zIndex: '50 !important' 
         // })
       }}

       return styles

  
  // const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  //    const styles = {
  //         control: (baseStyles, state) => ({
  //           ...baseStyles,
  //           color:'#6B7280', 
  //           backgroundColor: 'inherit',
  //           fontSize: '15px',
  //           borderColor: state.isFocused && 'grey',
  //           padding: inputTextPaddingSize || '4px 0px 4px 0px', borderRadius: '7px', borderColor: '#4B5563 !important',
  //           boxShadow: state.isFocused ? 'none' : baseStyles.boxShadow,
  //         }),
  //         input: (baseStyles) => ({
  //           ...baseStyles, 
  //           color:'#6B7280', 
            
  //         }),
  //         option: (baseStyles, state) => ({...baseStyles,
  //           fontSize: '14px', zIndex: '30 !important',
  //           // backgroundColor: state.isFocused ? '#334255'  : 'inherit'
  //           backgroundColor: isDarkMode && state.isFocused ? '#334255' : isDarkMode ? 'inherit' : state.isFocused ? '#E2E8F0' : 'inherit',
  //           color: isDarkMode ? '#94A3B8' : '#6B7280'
  //           // backgroundColor: '#d1d1d1',
  //         }),
  //         menu: (provided) => ({
  //           ...provided,
  //           // Conditionally set the background color based on isDarkMode
  //           backgroundColor: isDarkMode ? '#0F172B' : '#fff',
  //           color: isDarkMode ? '#4B5563' : '#334255',
  //         }),
  //         singleValue: provided => ({
  //           ...provided,
  //           color: isDarkMode? '#94A2B8' : '#334255', 
  //           fontSize: '14px'
  //         }), 
  //         placeholder: (provided, state) => ({
  //           ...provided,
  //           color: '#94A2B8', // Change this to your desired color
  //           fontSize: inputTextFontSize || '14px', // Optional: change this to adjust the font size

  //           // Additional placeholder styling can go here
  //         }),
          
  //         // group: baseStyles => ({...baseStyles, 
  //         //   zIndex: '50 !important' 
  //         // })
  //       }

  //       return styles
}

export default useSelectStyles





























// "use client"
// import { useEffect } from "react";

 


// const Styles = (inputTextPaddingSize, inputTextFontSize) => {

  
//     const isDarkMode = window?.matchMedia && window?.matchMedia('(prefers-color-scheme: dark)').matches;

//   // const [isDarkMode, setIsDarkMode] = useState(false);

//   // useEffect(() => {
//   //   if (typeof window !== 'undefined' && window.matchMedia) {
//   //     setIsDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);

//   //     // Optional: Add a listener to update the state if the user changes their preference
//   //     const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
//   //     const handleChange = (e) => setIsDarkMode(e.matches);

//   //     darkModeMediaQuery.addEventListener('change', handleChange);

//   //     // Cleanup the listener on unmount
//   //     return () => darkModeMediaQuery.removeEventListener('change', handleChange);
//   //   }
//   // }, []);


//     const styles = {
//          control: (baseStyles, state) => ({
//            ...baseStyles,
//            color:'#6B7280', 
//            backgroundColor: 'inherit',
//            fontSize: '15px',
//            borderColor: state.isFocused && '#94a3b8',
//            padding: inputTextPaddingSize || '4px 0px 4px 0px', borderRadius: '7px', 
//            borderColor: isDarkMode ? '#475569 !important' : '#94a3b8 !important',
//            boxShadow: state.isFocused ? 'none' : baseStyles.boxShadow,
//          }),
//          input: (baseStyles) => ({
//            ...baseStyles, 
//            color:'#6B7280', 
//          }),
//          option: (baseStyles, state) => ({...baseStyles,
//            fontSize: '14px', zIndex: '30 !important',
//            // backgroundColor: state.isFocused ? '#334255'  : 'inherit'
//            backgroundColor: isDarkMode && state.isFocused ? '#334255' : isDarkMode ? 'inherit' : state.isFocused ? '#E2E8F0' : 'inherit',
//            color: isDarkMode ? '#94A3B8' : '#6B7280'
//            // backgroundColor: '#d1d1d1',
//          }),
//          menu: (provided) => ({
//            ...provided,
//            // Conditionally set the background color based on isDarkMode
//            backgroundColor: isDarkMode ? '#0F172B' : '#fff',
//            color: isDarkMode ? '#4B5563' : '#334255',
//          }),
//          singleValue: provided => ({
//            ...provided,
//            color: isDarkMode? '#94A2B8' : '#334255', 
//            fontSize: '14px'
//          }), 
//          placeholder: (provided, state) => ({
//            ...provided,
//            color: '#94A2B8', // Change this to your desired color
//            fontSize: inputTextFontSize || '14px', // Optional: change this to adjust the font size

//            // Additional placeholder styling can go here
//          }),
         
//          // group: baseStyles => ({...baseStyles, 
//          //   zIndex: '50 !important' 
//          // })
//        }

//        return styles

  
//   // const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
//   //    const styles = {
//   //         control: (baseStyles, state) => ({
//   //           ...baseStyles,
//   //           color:'#6B7280', 
//   //           backgroundColor: 'inherit',
//   //           fontSize: '15px',
//   //           borderColor: state.isFocused && 'grey',
//   //           padding: inputTextPaddingSize || '4px 0px 4px 0px', borderRadius: '7px', borderColor: '#4B5563 !important',
//   //           boxShadow: state.isFocused ? 'none' : baseStyles.boxShadow,
//   //         }),
//   //         input: (baseStyles) => ({
//   //           ...baseStyles, 
//   //           color:'#6B7280', 
            
//   //         }),
//   //         option: (baseStyles, state) => ({...baseStyles,
//   //           fontSize: '14px', zIndex: '30 !important',
//   //           // backgroundColor: state.isFocused ? '#334255'  : 'inherit'
//   //           backgroundColor: isDarkMode && state.isFocused ? '#334255' : isDarkMode ? 'inherit' : state.isFocused ? '#E2E8F0' : 'inherit',
//   //           color: isDarkMode ? '#94A3B8' : '#6B7280'
//   //           // backgroundColor: '#d1d1d1',
//   //         }),
//   //         menu: (provided) => ({
//   //           ...provided,
//   //           // Conditionally set the background color based on isDarkMode
//   //           backgroundColor: isDarkMode ? '#0F172B' : '#fff',
//   //           color: isDarkMode ? '#4B5563' : '#334255',
//   //         }),
//   //         singleValue: provided => ({
//   //           ...provided,
//   //           color: isDarkMode? '#94A2B8' : '#334255', 
//   //           fontSize: '14px'
//   //         }), 
//   //         placeholder: (provided, state) => ({
//   //           ...provided,
//   //           color: '#94A2B8', // Change this to your desired color
//   //           fontSize: inputTextFontSize || '14px', // Optional: change this to adjust the font size

//   //           // Additional placeholder styling can go here
//   //         }),
          
//   //         // group: baseStyles => ({...baseStyles, 
//   //         //   zIndex: '50 !important' 
//   //         // })
//   //       }

//   //       return styles
// }

// export default Styles